<template>
  <div id="ldmt-consolidate-report">
    <overlay-loading-progress :LoadingFlag="OverlayLoadingFlag" />
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ YearName }} - {{ PageTitle }}</h2>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>{{ PageDescription }}</h4>
        <!-- <v-icon icon size="25px" color="primary">
          mdi-account-multiple-plus
        </v-icon>-->
      </v-card-subtitle>

      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container class="py-0">
          <v-form ref="form2" v-model="valid1" lazy-validation id="createForm">
            <v-row wrap>
              <v-col cols="12" md="3">
                <label>
                  <h6><span class="text-danger">*</span> Area</h6>
                </label>
                <v-autocomplete
                  @change="getZoneCodeOptions"
                  :reduce="(option) => option.value"
                  :loading="AreaCodeOptionsLoading"
                  :items="AreaCodeOptions"
                  :rules="AreaCodeRules"
                  v-model="AreaCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label>
                  <h6><span class="text-danger">*</span> Zone</h6>
                </label>
                <v-autocomplete
                  @change="getRegionCodeOptions"
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label>
                  <h6><span class="text-danger">*</span> Region</h6>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="RegionCodeOptionsLoading"
                  :items="RegionCodeOptions"
                  :rules="RegionCodeRules"
                  v-model="RegionCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="searchForm()"
                  :loading="SearchFlag"
                  color="#EDBE38"
                  class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text"
                  >Search</v-btn
                >
                <v-btn
                  @click.prevent="resetForm"
                  color="#0f9d58"
                  class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text"
                  >Reset</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-container class="py-0" v-if="StartupLoadingFlag">
          <v-skeleton-loader
            v-bind="attrs"
            type="table-tbody"
          ></v-skeleton-loader>
        </v-container>
        <v-container class="py-0" v-if="tableData1 <= 0">
          <v-row wrap v-if="tableData2.length == 0">
            <v-col align="center" cols="12" md="12">
              <h4>No records found.</h4>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="py-0" v-if="ResultFlag && tableData1.length > 0">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-btn
                v-if="!ExcelDownloadFlag"
                @click.prevent="generateExcelReport"
                :loading="ExcelLoadingFlag"
                target="_blank"
                color="#ff7f50"
                class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text"
              >
                <!-- <v-icon dark> mdi-file-excel </v-icon> -->
                Generate Report
              </v-btn>
              <v-btn
                v-if="ExcelFileName != '' && ExcelDownloadFlag == 1"
                :href="ExcelFileName"
                target="_blank"
                color="#2fb65a"
                class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text"
              >
                <v-icon dark> mdi-download </v-icon> Download Report
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            wrap
            align="center"
            style="display: flex; justify-content: center; align-items: center"
          >
            <v-col cols="12" sm="12" md="12" lg="4">
              <v-card dark hover class="zvp-card">
                <v-card-title class="card-title pa-0">
                  {{ tableColumns1.Desgination }}
                </v-card-title>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    align="center"
                    justify="center"
                  >
                    <v-img
                      v-if="tableColumns1.MemberPhoto != ''"
                      :src="tableColumns1.MemberPhoto"
                      alt="Member Photo"
                      width="100"
                      contain
                      class="ml-5 mt-5"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="8" lg="8">
                    <p class="para-font">
                      <v-icon>mdi-account-tie</v-icon>
                      {{ tableColumns1.ZvpName }}
                    </p>
                    <p class="para-font">
                      <v-icon>mdi-account-box</v-icon>
                      {{ tableColumns1.MemberId }}
                    </p>
                    <p class="para-font">
                      <v-icon>mdi-bank</v-icon> {{ tableColumns1.Zone }}
                    </p>
                    <p class="para-font">
                      <v-icon>mdi-office-building</v-icon>
                      {{ tableColumns1.LomName }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <p class="para-font">
                      <v-icon size="20">mdi-cellphone</v-icon>
                      {{ tableColumns1.ZvpMobileNumber }} &nbsp;
                      <v-icon size="20">mdi-email</v-icon>
                      {{ tableColumns1.Email }}
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col align="center" cols="12" sm="6" lg="4" md="4">
              <v-card dark hover class="ldmt-overall-card">
                <v-card-title class="card-title">
                  LDMT Reported for
                </v-card-title>
                <v-card-subtitle>
                  <br />
                  <h5 class="card-subtitle-text">
                    Pending: {{ LdmtData.PendingCount }} <br />
                    Completed: {{ LdmtData.CompletedCount }} <br />
                    Approved: {{ LdmtData.ApprovalCount }}
                  </h5>
                </v-card-subtitle>
                <v-card-actions> </v-card-actions>
              </v-card>
            </v-col>
            <v-col align="center" cols="12" sm="6" lg="4" md="4">
              <v-card dark hover class="lav-overall-card">
                <v-card-title class="card-title">
                  LAV Reported for
                </v-card-title>
                <v-card-subtitle>
                  <br />
                  <h5 class="card-subtitle-text">
                    Pending: {{ LavData.PendingCount }} <br />
                    Completed: {{ LavData.CompletedCount }} <br />
                    Approved: {{ LavData.ApprovalCount }}
                  </h5>
                </v-card-subtitle>
                <v-card-actions> </v-card-actions>
              </v-card>
            </v-col>

            <v-row
              v-for="(Details, index) in tableData1"
              :key="index"
              class="mb-4"
            >
              <!-- LO Details Card -->
              <v-col cols="12" sm="6" md="4" lg="4">
                <v-card dark hover class="lom-card">
                  <v-card-text class="text-left">
                    <h2 class="white--text">LO Details</h2>
                    <hr />
                    <div class="text-h5 white--text">
                      LO Name: {{ Details.LomName }}
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      President Name: {{ Details.PresidentName }}
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      Phone: {{ Details.PresidentMobileNo }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- LDMT Details Card -->
              <v-col cols="12" sm="6" md="4" lg="4">
                <v-card dark hover class="ldmt-card">
                  <v-card-text class="text-left">
                    <h2 class="white--text">LDMT Of: {{ Details.LomName }}</h2>
                    <hr />
                    <div class="text-h5 white--text">
                      Presidents Date: {{ Details.LdmtDateTxt }}
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      LDMT Status:
                      <v-chip :color="Details.CompletedStatusColor" dark>{{
                        Details.CompletedStatusTxt
                      }}</v-chip>
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      ZVP Date: {{ Details.ZvpLdmtDate }}
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      NHQ Approval Status:
                      <v-chip
                        :color="Details.LdmtNhqApprovalStatusColor"
                        draggable
                        dark
                        >{{ Details.LdmtNhqApprovalStatusTxt }}</v-chip
                      >
                    </div>
                    <br />
                    <v-btn
                      v-if="Details.ApprovalFlag"
                      color="success"
                      variant="elevated"
                      class="m-2"
                      @click="ApprovalStatus(Details)"
                    >
                      Approval
                    </v-btn>
                    <v-tooltip bottom v-if="Details.DownloadFlag">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :href="Details.FilePath"
                          target="_blank"
                          color="red"
                          small
                          class="text-white"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon left>mdi-file-pdf-box</v-icon> Download
                        </v-btn>
                      </template>
                      <span>Download Report </span>
                    </v-tooltip>
                    <v-btn
                      v-if="Details.LdmtRegenerateFlag"
                      @click="regeneratePDF(Details.LomTrainingId)"
                      color="#ffd166"
                      small
                      class="text-white m-2"
                    >
                      <v-icon left>mdi-sync</v-icon> Regenerate
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- LAV Details Card -->
              <v-col cols="12" sm="6" md="4" lg="4">
                <v-card dark hover class="pa-2 lav-card">
                  <v-card-text class="text-left">
                    <h2 class="white--text">LAV Of: {{ Details.LomName }}</h2>
                    <hr />
                    <div class="text-h5 white--text">
                      President Date: {{ Details.LavDateTxt }}
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      LAV Status:
                      <v-chip :color="Details.LavCompletedStatusColor" dark>{{
                        Details.LavCompletedStatusTxt
                      }}</v-chip>
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      ZVP Date: {{ Details.ZvpLavDate }}
                    </div>
                    <br />
                    <div class="text-h5 white--text">
                      NHQ Approval Status:
                      <v-chip
                        :color="Details.LavNhqApprovalStatusColor"
                        draggable
                        dark
                        >{{ Details.LavNhqApprovalStatusTxt }}</v-chip
                      >
                    </div>
                    <br />
                    <v-btn
                      v-if="Details.ApprovalFlag"
                      color="success"
                      variant="elevated"
                      class="m-2"
                      @click="LavApprovalStatus(Details)"
                    >
                      Approval
                    </v-btn>
                    <v-tooltip bottom v-if="Details.LavDownloadFlag">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :href="Details.LavFilePath"
                          target="_blank"
                          color="red"
                          small
                          class="text-white"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon left>mdi-file-pdf-box</v-icon> Download
                        </v-btn>
                      </template>
                      <span>Download Report </span>
                    </v-tooltip>
                    <v-btn
                      v-if="Details.LavRegenerateFlag"
                      @click="regeneratePDF(Details.LomTrainingLavId)"
                      color="#ffd166"
                      small
                      class="text-white m-2"
                    >
                      <v-icon left>mdi-sync</v-icon> Regenerate
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-row>
        </v-container>
        <!-- Administrative Purpose Only Card -->
        <v-container
          class="px-6"
          v-if="tableData1.length > 0 && Records.PermissionFlag"
        >
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
              <v-card class="mt-6 elevation-4 rounded-xl admin-card">
                <v-card-title
                  class="admin-card-header d-flex justify-space-between align-center"
                >
                  <!-- Left side -->
                  <div class="d-flex align-center">
                    <v-icon large left color="white" class="mr-2"
                      >mdi-shield-account</v-icon
                    >
                    <span class="text-h5 font-weight-bold white--text">
                      Administrative Purpose Only
                    </span>
                  </div>

                  <!-- Right side -->
                  <div
                    class="d-flex align-center"
                    v-if="Records.DocumentPath && Records.StatusText"
                  >
                    <!-- Status chip -->
                    <v-chip
                      :color="
                        Records.Status === 1
                          ? 'success'
                          : Records.Status === 0
                          ? 'error'
                          : 'red'
                      "
                      text-color="white"
                      class="font-weight-bold elevation-3"
                      style="
                        font-size: 16px;
                        letter-spacing: 0.5px;
                        min-width: 120px;
                        justify-content: center;
                        border-radius: 999px;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                      "
                    >
                      <v-icon left small v-if="Records.Status === 1"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon left small v-else-if="Records.Status === 0"
                        >mdi-close-circle</v-icon
                      >
                      <v-icon left small v-else>mdi-alert-circle</v-icon>
                      {{ Records.StatusText }}
                    </v-chip>

                    <!-- PDF download button -->
                    <v-btn
                      v-if="Records.PdfDownloadFlag"
                      :href="Records.DocumentPath"
                      target="_blank"
                      icon
                      color="white"
                      class="ml-2"
                    >
                      <v-icon color="red" large>mdi-file-pdf-box</v-icon>
                    </v-btn>
                  </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                  <v-simple-table class="admin-metrics-table">
                    <thead>
                      <tr>
                        <th class="text-left primary--text text-subtitle-1">
                          Metric
                        </th>
                        <th class="text-center primary--text text-subtitle-1">
                          Value
                        </th>
                        <th class="text-right primary--text text-subtitle-1">
                          Completion
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="py-3">
                          <div class="d-flex align-center">
                            <v-icon color="#3a67b1" class="mr-2"
                              >mdi-file-document-outline</v-icon
                            >
                            <span>LDMT Reports</span>
                          </div>
                        </td>
                        <td class="text-center font-weight-bold py-3">
                          <v-chip color="#3a67b1" text-color="white"
                            >{{ Records.LdmtCompletedCount }} /
                            {{ Records.LdmtLomCount }}</v-chip
                          >
                        </td>
                        <td class="text-right font-weight-bold py-3">
                          <v-progress-linear
                            :value="Records.LdmtPercentage"
                            color="#3a67b1"
                            height="8"
                            rounded
                            class="mb-1"
                          ></v-progress-linear>
                          <span>{{ Records.LdmtPercentage }}%</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="py-3">
                          <div class="d-flex align-center">
                            <v-icon color="#56bda3" class="mr-2"
                              >mdi-file-document-outline</v-icon
                            >
                            <span>LAV Reports</span>
                          </div>
                        </td>
                        <td class="text-center font-weight-bold py-3">
                          <v-chip color="#56bda3" text-color="white"
                            >{{ Records.LavCompletedCount }} /
                            {{ Records.LavLomCount }}</v-chip
                          >
                        </td>
                        <td class="text-right font-weight-bold py-3">
                          <v-progress-linear
                            :value="Records.lavCompletion"
                            color="#56bda3"
                            height="8"
                            rounded
                            class="mb-1"
                          ></v-progress-linear>
                          <span>{{ Records.LavPercentage }}%</span>
                        </td>
                      </tr>
                      <tr class="overall-row">
                        <td class="py-4">
                          <div class="d-flex align-center">
                            <v-icon color="success" class="mr-2"
                              >mdi-check-circle</v-icon
                            >
                            <span class="font-weight-bold"
                              >Overall Completion</span
                            >
                          </div>
                        </td>
                        <td class="text-center font-weight-bold py-4">
                          <v-chip color="success" text-color="white"
                            >Total</v-chip
                          >
                        </td>
                        <td class="text-right font-weight-bold py-4">
                          <v-progress-linear
                            :value="Records.OverallPercentage"
                            color="success"
                            height="10"
                            rounded
                            class="mb-1"
                          ></v-progress-linear>
                          <span class="text-success"
                            >{{ Records.OverallPercentage }}%</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>

                  <v-row justify="center" class="mt-6">
                    <v-btn
                      color="success"
                      rounded
                      large
                      class="px-6 elevation-2"
                      @click="MspApprovalStatus(Records)"
                    >
                      <v-icon left>mdi-check-all</v-icon> Approve Reports
                    </v-btn>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <br />
        <br />
      </v-card-text>
    </v-card>
    <v-dialog v-model="previewRecordPrompt" max-width="75%">
      <ldmt-approval-status
        pageDescription="LDMT Approval Status"
        category="1"
        :showDialog="previewRecordPrompt"
        @hideDialog="hidePreviewRecordPrompt($event)"
        :row="selectedData"
        v-if="previewRecordPrompt"
      ></ldmt-approval-status>
    </v-dialog>
    <v-dialog v-model="lavRecordPrompt" max-width="75%">
      <lav-approval-status
        pageDescription="LAV Approval Status"
        category="2"
        :showLavDialog="lavRecordPrompt"
        @hideLavDialog="hideLavRecordPrompt($event)"
        :rowData="recordData"
        v-if="lavRecordPrompt"
      ></lav-approval-status>
    </v-dialog>
    <v-dialog v-model="mspRecordPrompt" max-width="75%" max-height="200%">
      <msp-approval
        pageDescription="MSP Approval"
        :showMspDialog="mspRecordPrompt"
        @hideDialog="hideMspRecordPrompt($event)"
        :row="recordData"
        v-if="mspRecordPrompt"
      ></msp-approval>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import LdmtApprovalStatus from "@/view/pages/erp/ldmt/LdmtApprovalStatus.vue";
import LavApprovalStatus from "@/view/pages/erp/ldmt/LavApprovalStatus.vue";
import MspApproval from "@/view/pages/erp/ldmt/MspApproval.vue";
export default {
  mixins: [common],
  components: { LdmtApprovalStatus, LavApprovalStatus, MspApproval },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      OverlayLoadingFlag: false,
      StartupLoadingFlag: false,
      FloatingButtonFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      mspRecordPrompt: false,
      LdmtData: {},
      LavData: {},

      rows: [],
      tableColumns1: {},
      selected: [],
      search: "",
      CurrentYearId: 0,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      selectedData: {},

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      lavRecordPrompt: false,

      TableDisplayFlag1: false,

      zone: {},
      lom: {},
      Details: [],

      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,
      Records: [],
      JciYearCode: "",

      AreaCodeRules: [(v) => !!v || "Area is required"],
      AreaCode: "",
      AreaCodeOptions: [],
      AreaCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionCodeRules: [(v) => !!v || "Region is required"],
      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,

      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      ExcelLoadingFlag: false,
      search1: "",
      selected1: "",
      tableData1: [],
      tableOptions1: {},

      tableColumns2: [],
      tableData2: [],
      tableOptions2: {},

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      ExcelDownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var PagePermissionFlag = tr.PagePermissionFlag;
        console.log({ PagePermissionFlag });

        if (!PagePermissionFlag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    AreaCodeOptions: function () {
      console.log("watch AreaCodeOptions");
      this.AreaCodeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    RegionCodeOptions: function () {
      console.log("watch RegionCodeOptions");
      this.RegionCodeOptionsLoading = false;
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "ldmt",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getAreaCodeOptions();
    },
    ApprovalStatus(tr) {
      console.log("ApprovalStatus called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    LavApprovalStatus(tr) {
      console.log("LavApprovalStatus called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.lavRecordPrompt = true;
        this.recordData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    MspApprovalStatus(tr) {
      console.log("MspApprovalStatus called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.mspRecordPrompt = true;
        this.recordData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    hideLavRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.lavRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    hideMspRecordPrompt(flag) {
      console.log("hideMspRecordPrompt called");
      console.log({ flag });
      this.mspRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    addData(tr) {
      console.log("addData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var url = "/ldmt/send-report";
        var LomCode = tr.LomId;
        console.log({ LomCode });
        var params = {
          v1: LomCode,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one LO to send report";
        this.sweetAlert("error", message, false);
      }
    },
    resetForm() {
      this.search = "";
      this.tableData2 = [];
      this.tableData1 = [];
      this.selected = [];
      this.$refs.form2.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    getAreaCodeOptions() {
      console.log("getAreaCodeOptions called");
      this.AreaCodeOptionsLoading = true;
      var selectbox1_source = "AreaCode";
      var selectbox1_destination = "AreaCodeOptions";
      var selectbox1_url = "api/year-wise-lom/area-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
        YearCode: this.JciYearCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      var areaCode = this.AreaCode;
      this.LomCodeOptions = [];
      console.log("yearCode=" + yearCode + ", areaCode=" + areaCode);
      if (yearCode != "" && areaCode != "") {
        this.ZoneCode = "";
        this.ZoneCodeOptionsLoading = true;
        this.tableData2 = [];
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 7,
          AreaCode: areaCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getRegionCodeOptions() {
      console.log("getRegionCodeOptions called");
      var YearCode = this.JciYearCode;
      var AreaCode = this.AreaCode;
      var ZoneCode = this.ZoneCode;
      this.RegionCodeOptions = [];
      this.LomCodeOptions = [];
      console.log(
        "YearCode=" +
          YearCode +
          ", AreaCode=" +
          AreaCode +
          ", ZoneCode=" +
          ZoneCode
      );
      if (YearCode != "" && AreaCode != "" && ZoneCode != "") {
        this.RegionCode = "";
        this.RegionCodeOptionsLoading = true;
        this.tableData2 = [];
        var selectbox1_source = "RegionCode";
        var selectbox1_destination = "RegionCodeOptions";
        var selectbox1_url = "api/year-wise-lom/region-options";
        var selectbox1_conditions_array = {
          UserInterface: 4,
          YearCode: YearCode,
          AreaCode: AreaCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    searchForm() {
      console.log("searchForm called");

      this.mspCertificate();

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? 0 : LomCode;
      console.log("LomCode=" + LomCode);

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.TrainingData = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/lom-training/ldmt-lav-consolidate-report";
        var upload = {
          UserInterface: 1,
          Area: this.AreaCode,
          Zone: this.ZoneCode,
          Region: this.RegionCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.tableData1 = [];
        this.tableColumns1 = [];
        this.LoadingFlag = true;
        this.SearchFlag = true;
        this.LdmtData = {};
        this.LavData = {};

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;
        let tableOptions1 = {};
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;
            thisIns.ResultFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            thisIns.ExcelDownloadFlag = false;

            if (flag == 1) {
              thisIns.tableColumns1 = records.ZoneVicePresident;
              thisIns.tableData1 = records.LomData;
              console.log("tableData1", thisIns.tableData1);
              console.log("tableColumns1", thisIns.tableColumns1);
              thisIns.LdmtData = records.LdmtData;
              thisIns.LavData = records.LavData;
              thisIns.tableOptions1 = response.data.records.TableOptions;
              tableOptions1 = thisIns.tableOptions1;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill required fields.";
        this.toast("error", message);
      }
    },
    generateExcelReport() {
      console.log("generateExcelReport is called");

      var validate1 = this.$refs.form2.validate();
      var AreaCode = this.AreaCode;
      console.log("validate1=" + validate1 + ", AreaCode=" + AreaCode);
      this.ExcelLoadingFlag = true;

      if (validate1) {
        this.ExcelFileName = "";

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-training/generate-excel-report";
        var upload = {
          UserInterface: 1,
          AreaCode: this.AreaCode,
          ZoneCode: this.ZoneCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()

            thisIns.ExcelLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.ExcelFileName = records.ExcelFileName;
              thisIns.ExcelDownloadFlag = records.ExcelDownloadFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
            thisIns.ExcelLoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    regeneratePDF(LomTrainingId) {
      console.log("regeneratePDF called");

      console.log("LomTrainingId=", LomTrainingId);

      var token = this.$session.get("token") || "";

      if (!LomTrainingId) {
        this.toast("error", "Training ID is missing.");
        return;
      }
      this.OverlayLoadingFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom-training/regenerate-pdf";
      var upload = {
        UserInterface: 1,
        LomTraining: LomTrainingId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.OverlayLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          if (flag == 1) {
            thisIns.toast("success", output);
            thisIns.searchForm();
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error);
          thisIns.OverlayLoadingFlag = false;
        });
    },
    mspCertificate() {
      console.log("mspCertificate called");

      console.log("AreaCode=", this.AreaCode);
      console.log("ZoneCode=", this.ZoneCode);
      console.log("RegionCode=", this.RegionCode);

      var token = this.$session.get("token") || "";

      this.OverlayLoadingFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/msp-certificate/info";
      var upload = {
        UserInterface: 1,
        Area: this.AreaCode,
        Zone: this.ZoneCode,
        Region: this.RegionCode,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var flag = 0;
      var records = "";

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.OverlayLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;

          records = response.data.records;
          console.log({ records });

          console.log("output=" + output + ", flag=" + flag);

          if (flag == 1) {
            thisIns.Records = records;
            console.log("Records", thisIns.Records);
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error);
          thisIns.OverlayLoadingFlag = false;
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
    this.tableColumns1.push(
      { text: "Paid Date", value: "PaidDateTxt" },
      { text: "Year", value: "YearName" },
      {
        text: "Subscription Description",
        value: "ContributionTypeDescription",
      },
      { text: "Paid Count", value: "PaidCount" },
      { text: "Remaining Count", value: "RemainingCount" },
      { text: "Add members", value: "actions" }
    );
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4";

#ldmt-consolidate-report {
  .card-title {
    font-size: 25px;
    font-family: "Lora", serif;
    padding: 20px;
    text-align: center;
    word-wrap: break-word;
  }
  .card-subtitle-text {
    font-size: 40px;
    font-family: "Lobster", cursive;
    color: white;
    text-align: center;
  }
  .card-subtext {
    font-size: 40px;
    font-family: "Roboto", cursive !important;
    color: white;
    text-align: center;
  }
  .zvp-card {
    background-color: #0097d7;
    height: 280px;
  }
  .ldmt-overall-card {
    background-color: #3a67b1;
  }
  .lav-overall-card {
    background-color: #56bda3;
  }
  .lom-card {
    background-color: #0097d7;
    height: 360px;
    overflow-y: auto;
  }
  .ldmt-card {
    background-color: #3a67b1;
    height: 360px;
    overflow-y: auto;
  }
  .lav-card {
    background-color: #56bda3;
    height: 360px;
    overflow-y: auto;
  }
  .font {
    font-size: 20px;
    color: white;
    font-family: "Times New Roman", Times, serif;
  }
  .para-font {
    font-size: 15px;
  }

  // Administrative card styling
  .admin-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1) !important;
    }

    .admin-card-header {
      background: linear-gradient(45deg, #3a67b1, #56bda3);
      padding: 20px;
      color: white;
    }

    .admin-metrics-table {
      border-collapse: separate;
      border-spacing: 0;

      th {
        border-bottom: 2px solid #eee;
        font-size: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 10px;
      }

      td {
        border-bottom: 1px solid #f5f5f5;
        padding: 15px 10px;
        vertical-align: middle;
      }

      .overall-row {
        background-color: #f9f9f9;
        td {
          border-top: 2px solid #eee;
          border-bottom: none;
          padding-top: 20px;
          padding-bottom: 20px;
        }
      }
    }
  }
}
</style>